import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper from 'swiper';
import {  Autoplay , Navigation, Pagination , FreeMode, EffectFade, Controller } from 'swiper/modules';

function wherenext() {
    const where_next = document.querySelector('[data-target="where_next"]');
    if (!where_next) { return; }
    
   

    const where_next_0 = document.querySelector('[data-target="where_next_0"]');
    const where_next_1 = document.querySelector('[data-target="where_next_1"]');
const where_next_2 = document.querySelector('[data-target="where_next_2"]');

const topcorner = document.querySelector('.topcorner');
const bottomcorner = document.querySelector('.bottomcorner');





const container = document.querySelector('.containerwhere'); // The container

if (where_next_1 && topcorner && bottomcorner && container) {
  // Get bounding box of where_next_1
  const rect = where_next_1.getBoundingClientRect();
  
  // Get bounding box of the container
  const containerRect = container.getBoundingClientRect();

  // Calculate relative top and bottom positions of where_next_1 relative to the container
  const relativeTopPosition = rect.top - containerRect.top;
  const relativeBottomPosition = rect.bottom - containerRect.top;

  // Apply the relative top position to the topcorner
  topcorner.style.position = 'absolute';
  topcorner.style.top = `${relativeTopPosition}px`;

  // Apply the relative bottom position to the bottomcorner
  bottomcorner.style.position = 'absolute';
  bottomcorner.style.top = `${relativeBottomPosition}px`;


}

 


let tl, tlback;


where_next_0.addEventListener('mouseover', function() {
    if (tlback && tlback.isActive()) {
        tlback.kill();  
    }
    
    tl = gsap.timeline();
    tl.to(topcorner, { autoAlpha:0, scaleX: 0, duration: 0.2, ease: "power2.in" });
});

where_next_0.addEventListener('mouseout', function() {
    if (tl && tl.isActive()) {
        tl.kill();  
    }
    
    tlback = gsap.timeline();
    tlback.to(topcorner, { autoAlpha:1, scaleX: 1, duration: 0.2, ease: "power2.in" });
});

where_next_1.addEventListener('mouseover', function() {
    if (tlback && tlback.isActive()) {
        tlback.kill();  
    }
    
    tl = gsap.timeline();
    tl.to(topcorner, { autoAlpha:0, scaleX: 0, duration: 0.2, ease: "power2.in" }, "same")
    .to(bottomcorner, { autoAlpha:0, scaleX: 0, duration: 0.2, ease: "power2.in" }, "same")
});

where_next_1.addEventListener('mouseout', function() {
    if (tl && tl.isActive()) {
        tl.kill();  
    }
    
    tlback = gsap.timeline();
    tlback.to(topcorner, { autoAlpha:1, scaleX: 1, duration: 0.2, ease: "power2.in" },"same")
    .to(bottomcorner, { autoAlpha:1, scaleX: 1, duration: 0.2, ease: "power2.in" }, "same")
});


where_next_2.addEventListener('mouseover', function() {
    if (tlback && tlback.isActive()) {
        tlback.kill();  
    }
    
    tl = gsap.timeline();
    tl.to(bottomcorner, { autoAlpha:0, scaleX: 0, duration: 0.2, ease: "power2.in" });
});

where_next_2.addEventListener('mouseout', function() {
    if (tl && tl.isActive()) {
        tl.kill();  
    }
    
    tlback = gsap.timeline();
    tlback.to(bottomcorner, { autoAlpha:1, scaleX: 1, duration: 0.2, ease: "power2.in" });
});

    
 
      
}


export { wherenext }; 